PJQ.collections.punchlists = {};

PJQ.models.punchlists = {};

PJQ.views.punchlists = {};

//Routes
PJQ.modules.punchList = {
	routes: [
		{
			route: 'projects/:projectId/punchlists',
			name: 'punchList',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "punchlists");
			}
		},
		{
			route: 'projects/:projectId/punchlists/:punchListItemId',
			name: 'punchListItem',
			callback: function (projectId, punchListItemId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "punchlists", {
					punchListItemId: parseInt(punchListItemId)
				});
			}
		}
	]
};

PJQ.app.addRoutes(PJQ.modules.punchList.routes);
// Models
PJQ.models.punchlists.PunchlistItem = PJQ.models.BaseModel.extend({
    notifyName: 'Punch List Item',
    idAttribute: "punchlistItemId",
    endpoint: function () {
        let arr;
        if (this.isNew() && this.get('projectId') > 0) {
            arr = [
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'punchlists',
                    value: this.id
                }
            ];
        } else if (this.isNew() && this.get('templateId') > 0) {
            arr = [
                {
                    endpoint: 'punchlists'
                },
                {
                    endpoint: 'templates',
                    value: this.get('templateId')
                },
                {
                    endpoint: 'item'
                }
            ];
        } else {
            arr = [
                {
                    endpoint: 'punchlists',
                    value: this.id
                }
            ];
        }

        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    },
    afterInit: function () {
        if (this.get('customFieldValues') == null) {
            this.set('customFieldValues', [], {
                silent: true
            });
        }

        this.on('change:assignedTo', _.bind(function () {
            let assignedTo = this.get('assignedTo');
            if (assignedTo instanceof PJQ.models.projectContacts.ProjectContact) {
                this.assignedTo = this.get('assignedTo');
            } else if (assignedTo != null) {
                this.assignedTo = new PJQ.models.projectContacts.ProjectContact(this.get('assignedTo'));
            } else {
                this.assignedTo = null;
            }

            if (this.get('status') === PJQ.constants.punchlists.statuses.NEW || PJQ.constants.punchlists.statuses.NOT_RESOLVED) {
                this.ballInCourt = this.assignedTo;
                this.set('ballInCourt', this.ballInCourt);
            }
        }, this));
    },
    parse: function (model) {
        if (!model)
            return model;

        this.groups = new PJQ.collections.groups.Groups(model.groups);

        if (model.createdBy != null) {
            this.createdBy = new PJQ.models.projectContacts.ProjectContact(model.createdBy);
        } else {
            this.createdBy = null;
        }

        if (model.assignedTo) {
            this.assignedTo = new PJQ.models.projectContacts.ProjectContact(model.assignedTo);
        } else {
            this.assignedTo = null;
        }

        if (_.size(model.distributionList) > 0) {
            this.distributionList = new PJQ.collections.projectContacts.ProjectContacts(model.distributionList);
        } else if (!this.distributionList) {
            this.distributionList = new PJQ.collections.projectContacts.ProjectContacts();
        }

        // if (model.workCompletedBy) {
        //     this.workCompletedBy = new PJQ.models.projectContacts.ProjectContact(model.workCompletedBy);
        // }
        // else{
        //     this.workCompletedBy = null;
        // }
        //
        // if (model.resolvedBy) {
        //     this.resolvedBy = new PJQ.models.projectContacts.ProjectContact(model.resolvedBy);
        // }
        // else{
        //     this.resolvedBy = null;
        // }

        if (_.size(model.comments) > 0) {
            this.comments = new PJQ.collections.punchlists.PunchlistItemComments(model.comments);
        } else {
            this.comments = new PJQ.collections.punchlists.PunchlistItemComments();
        }

        if (_.size(model.attachments) > 0) {
            this.attachments = new PJQ.collections.punchlists.PunchlistItemAttachments(model.attachments);
        } else {
            this.attachments = new PJQ.collections.punchlists.PunchlistItemAttachments();
        }

        if (_.size(model.beforeAttachments) > 0) {
            this.beforeAttachments = new PJQ.collections.punchlists.PunchlistItemAttachments(model.beforeAttachments);
        } else {
            this.beforeAttachments = new PJQ.collections.punchlists.PunchlistItemAttachments();
        }

        if (_.size(model.afterAttachments) > 0) {
            this.afterAttachments = new PJQ.collections.punchlists.PunchlistItemAttachments(model.afterAttachments);
        } else {
            this.afterAttachments = new PJQ.collections.punchlists.PunchlistItemAttachments();
        }

        if (model.customFieldValues == null) {
            model.customFieldValues = [];
        }

        return model;
    },
    getDeepLink: function () {
        let projectId = this.get('projectId');
        if (!(this.id > 0) || !(projectId > 0)) {
            return null;
        }
        return '#projects/' + projectId.toString() + '/punchlists/' + this.id.toString();
    },
    getStatusColor: function () {
        if (this.get('status') == null) {
            this.set('status', PJQ.constants.punchlists.statuses.NEW);
        }

        if (this.assignedTo != null && this.get('status') === PJQ.constants.punchlists.statuses.NEW) {
            return PJQ.constants.punchlists.statusColors[PJQ.constants.punchlists.statuses.ASSIGNED];
        }
        return PJQ.constants.punchlists.statusColors[this.get('status')];
    },
    getStatusName: function () {
        if (this.get('status') == null) {
            this.set('status', PJQ.constants.punchlists.statuses.NEW);
        }

        if (this.assignedTo != null && this.get('status') === PJQ.constants.punchlists.statuses.NEW) {
            return PJQ.constants.punchlists.statusNames[PJQ.constants.punchlists.statuses.ASSIGNED];
        } else if (this.get('status') === PJQ.constants.punchlists.statuses.WORK_COMPLETED) {
            let workCompletedOverride = PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PUNCH_LIST_WORK_COMPLETED_STATUS_OVERRIDE);
            if (workCompletedOverride != null) {
                return workCompletedOverride;
            }
        }
        return PJQ.constants.punchlists.statusNames[this.get('status')];
    },
    getPriorityColor: function () {
        if (this.get('priority') == null) {
            this.set('priority', PJQ.constants.punchlists.priorities.LOW);
        }
        return PJQ.constants.punchlists.priorityColors[this.get('priority')];
    },
    getPriorityName: function () {
        if (this.get('priority') == null) {
            this.set('priority', PJQ.constants.punchlists.priorities.LOW);
        }
        return PJQ.constants.punchlists.priorityNames[this.get('priority')];
    },
    beforeSave: function () {
        this.set({
            groups: this.groups.toJSON(),
            assignedTo: this.assignedTo?.toJSON(),
            distributionList: this.distributionList.toJSON(),
            attachments: this.attachments.getChangedModels(),
            beforeAttachments: this.beforeAttachments.getChangedModels(),
            afterAttachments: this.afterAttachments.getChangedModels(),
            comments: this.comments.getChangedModels()
        });
    },
    fetchNotifications: function (callback) {
        if (this.notifications == null) {
            this.notifications = new PJQ.collections.punchlists.Notifications(null, {
                punchlistItem: this
            })
        }

        this.notifications.fetch({
            success: _.bind(function () {
                callback(this.notifications);
            }, this)
        });
    },
    distribute: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/distribute',
        }).post().done((response) => {
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((res) => {
            let err = null;
            if (res.responseJSON && res.responseJSON.message) {
                err = res.responseJSON.message;
            }
            if (typeof callback === 'function') {
                callback(false, err);
            }
        });
    },
});

PJQ.models.punchlists.PunchlistItemComment = PJQ.models.BaseModel.extend({
    idAttribute: "commentId",
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'punchlists',
                value: this.get('punchlistItemId')
            },
            {
                endpoint: 'comments',
                value: this.get('commentId')
            }
        ])
    },
    parse: function (model) {
        if (!model) {
            return model;
        }

        if (model.createdBy != null) {
            this.createdBy = new PJQ.models.projectContacts.ProjectContact(model.createdBy);
        }

        return model;
    }
});

PJQ.models.punchlists.EditHistoryItem = PJQ.models.BaseModel.extend({
    parse: function (model) {
        if (!model)
            return model;

        this.createdOnDisplay = PJQ.helpers.dateHelpers.getDateString(new Date(model.createdOn), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);

        this.createdByDisplay = '';

        if (model.createdBy && model.createdBy.companyName)
            this.createdByDisplay = model.createdBy.contactName + ' (' + model.createdBy.companyName + ')';

        this.oldValueDisplay = model.oldValue;
        this.newValueDisplay = model.newValue;

        if (model.fieldType === 'DATE') {
            if (model.oldValue)
                this.oldValueDisplay = PJQ.helpers.dateHelpers.getDateString(new Date(model.oldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
            if (model.newValue)
                this.newValueDisplay = PJQ.helpers.dateHelpers.getDateString(new Date(model.newValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
        } else if (model.fieldType === 'DATETIME') {
            if (model.oldValue)
                this.oldValueDisplay = PJQ.helpers.dateHelpers.getDateString(new Date(model.oldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
            if (model.newValue)
                this.newValueDisplay = PJQ.helpers.dateHelpers.getDateString(new Date(model.newValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
        }

        return model;
    }
});

PJQ.models.punchlists.PunchlistItemAttachment = PJQ.models.files.File.extend({
    idAttribute: 'attachmentId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'punchlists',
                value: this.get('punchlistItemId')
            },
            {
                endpoint: 'attachments',
                value: this.id
            }
        ]);
    }
});

PJQ.models.punchlists.PunchlistCustomField = PJQ.models.customFields.CustomField.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'punchlists'
            },
            {
                endpoint: 'customFields',
                value: this.id
            }
        ])
    }
});

PJQ.models.punchlists.Notification = PJQ.models.notifications.Notification.extend({
    notificationTypeNames: PJQ.constants.punchlists.notificationTypeNames,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'punchlists',
                value: this.collection.options.punchlistItem.id
            },
            {
                endpoint: 'notifications',
                value: this.id
            }
        ])
    }
});

PJQ.models.punchlists.Settings = PJQ.models.BaseModel.extend({
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('project').id
            },
            {
                endpoint: 'punchlists'
            },
            {
                endpoint: 'settings'
            }
        ])
    },
    parse: function (model) {
        if (!model)
            return model;

        this.projectContacts = new PJQ.collections.punchlists.ProjectContactSettings(model.projectContacts);
        _.each(this.projectContacts.models, _.bind(function (setting) {
            let matchProjectContact = PJQ.app.session.project.projectContacts.findWhere({id: setting.get('id')});
            if (matchProjectContact != null) {
                setting.set(matchProjectContact.attributes, {
                    isSilent: true
                });
            }
        }, this));

        return model;
    },
    beforeSave: function () {
        this.set('projectContacts', this.projectContacts.filter(function (projectContact) {
            return projectContact.hasChanged();
        }));
    }
});

PJQ.models.punchlists.PunchListUserSettings = PJQ.models.BaseModel.extend({
    endpoint: function () {
        let params = [];
        if (this.options.forCompany) {
            params.push({
                parameter: 'forCompany',
                value: true
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'punchlists'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ], params);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});


PJQ.models.punchlists.ProjectContactSetting = PJQ.models.BaseModel.extend({});

PJQ.models.punchlists.Template = PJQ.models.BaseModel.extend({
    idAttribute: 'templateId',
    notifyName: 'Template',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'punchlists'
            },
            {
                endpoint: 'templates',
                value: this.id
            }
        ], this.get('projectId') > 0 ? [
            {
                parameter: 'projectId',
                value: this.get('projectId')
            },
            {
                parameter: 'copyComments',
                value: this.get('copyComments')
            },
            {
                parameter: 'copyAssignee',
                value: this.get('copyAssignee')
            },
            {
                parameter: 'copyGroups',
                value: this.get('copyGroups')
            },
            {
                parameter: 'overwrite',
                value: this.get('overwrite')
            }
        ] : null);
    },
    parse: function (model) {
        if (!model)
            return model;

        if (model.project != null) {
            this.project = model.project;
        } else {
            this.user = PJQ.app.session.user;
        }

        this.groups = new PJQ.collections.groups.Groups(model.groups);

        if (model.createdBy != null) {
            this.createdBy = new PJQ.models.projectContacts.ProjectContact(model.createdBy);
        } else {
            this.createdBy = null;
        }

        if (model.assignee != null) {
            this.assignee = new PJQ.models.projectContacts.ProjectContact(model.assignee);
        } else {
            this.submitter = null;
        }

        this.comments = new PJQ.collections.submittals.Comments(model.comments);

        this.attachments = new PJQ.collections.submittals.Attachments(model.attachments);

        if (model.punchlistItems)
            this.punchlistItems = new PJQ.collections.punchlists.PunchlistItems(model.punchlistItems);
        else if (model.items)
            this.punchlistItems = new PJQ.collections.punchlists.PunchlistItems(model.items);
        else
            this.punchlistItems = new PJQ.collections.punchlists.PunchlistItems();

        return model;
    }
});


// Collections
PJQ.collections.punchlists.PunchlistItems = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.punchlists.PunchlistItem,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'punchlists'
            }
        ])
    }
});

PJQ.collections.punchlists.Notifications = PJQ.collections.notifications.Notifications.extend({
    model: PJQ.models.punchlists.Notification,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'punchlists',
                value: this.options.punchlistItem.id
            },
            {
                endpoint: 'notifications'
            }
        ])
    }
});

PJQ.collections.punchlists.EditHistoryItems = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.punchlists.EditHistoryItem
});

PJQ.collections.punchlists.PunchlistItemComments = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.punchlists.PunchlistItemComment
});

PJQ.collections.punchlists.PunchlistItemAttachments = PJQ.collections.files.Files.extend({
    model: PJQ.models.punchlists.PunchlistItemAttachment
});

PJQ.collections.punchlists.ProjectContactSettings = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.punchlists.ProjectContactSetting
});

PJQ.collections.punchlists.PunchlistCustomFields = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.punchlists.PunchlistCustomField,
    options: {
        masterUserId: null
    },
    endpoint: function () {
        let projectId = null;
        if (this.options.project != null) {
            projectId = this.options.project.id
        } else if (this.options.projectId > 0) {
            projectId = this.options.projectId;
        }

        if (projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: projectId
                },
                {
                    endpoint: 'punchlists'
                },
                {
                    endpoint: 'customFields'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'punchlists'
                },
                {
                    endpoint: 'customFields'
                }
            ],
            [
                {
                    parameter: 'masterUserId',
                    value: this.options.masterUserId > 0 ? this.options.masterUserId : PJQ.app.session.get('masterUserId')
                }
            ]);
    }
});

PJQ.collections.punchlists.Templates = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.punchlists.Template,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'punchlists'
            },
            {
                endpoint: 'templates'
            }
        ]);
    }
});

PJQ.views.punchlists.PunchlistView = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PUNCHLISTS, 'Punchlist-Management'),
        punchListItemId: null
    },
    events: {
        'click .btn-punchlist-settings': 'viewPunchListSettings',
        'click .export-detailed': 'exportDetailedList',
        'click .export-list': 'exportList',
        'click .btn-add-punchlist-item': 'addClicked',
        'click .btn-edit-punchlist-item': 'editClicked',
        'click .btn-delete-punchlist-item': 'deleteClicked',
        'click .btn-save-a-template': 'saveTemplate',
        'click .btn-import-template': 'importTemplate'
    },
    beforeFirstRender: function () {
        this.options.isAdmin = true;
        if (PJQ.app.session.project != null) {
            this.options.project = PJQ.app.session.project;
            this.options.isAdmin = (PJQ.app.session.user != null && this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')) && this.options.project.hasPermission('punchList.isAdmin');
        }

        this.isFetched = false;
        this.preferences = this.options.project ? this.options.project.preferences : PJQ.app.session.preferences;
        this.options.userSettings = new PJQ.models.punchlists.PunchListUserSettings();
        let fnFetch = _.bind(function () {
            this.options.userSettings.fetch({
                success: _.bind(function () {
                    let fnRender = _.bind(function (customFields) {
                        this.options.customFields = customFields;
                        if (this.collection == null && this.options.project != null) {
                            let punchListItems = new PJQ.collections.punchlists.PunchlistItems(null, {
                                project: this.options.project
                            });
                            punchListItems.fetch({
                                success: _.bind(function () {
                                    this.collection = punchListItems;
                                    this.isFetched = true;
                                    this.render();
                                }, this)
                            });
                            return false;
                        } else {
                            this.isFetched = true;
                            this.render();
                        }
                    }, this);
                    if (this.options.project != null) {
                        this.options.project.fetchPunchListCustomFields(_.bind(function (customFields) {
                            fnRender(customFields);
                        }, this));
                    } else {
                        PJQ.app.session.fetchPunchListCustomFields(null, _.bind(function (customFields) {
                            fnRender(customFields);
                        }, this));
                    }
                }, this)
            });
        }, this)

        if (this.options.project != null && this.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_LOCATIONS)) {
            this.options.project.fetchLocations(_.bind(function (locations) {
                this.locations = locations;
                fnFetch();
            }, this));
        } else {
            fnFetch();
        }
    },
    renderData: function () {
        return {
            project: this.options.project,
            locations: this.locations
        };
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.renderDataTable();

        //If there was a passed in item to be shown (for a route), show it now
        if (this.options.punchListItemId > 0) {
            let item = this.collection.get(this.options.punchListItemId);
            this.options.punchListItemId = null;
            if (item != null) {
                this.editPunchlistItem(item);
            }
        }
    },
    renderDataTable() {
        let self = this,
            userSettings = this.options.userSettings.getSettings(PJQ.constants.punchlists.view.PUNCHLISTS);
        this.punchlistDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.punch-list-items'),
            rowId: "cid",
            data: this.collection.models,
            language: {
                emptyTable: 'Click "Add Item" to create a Punch List Item',
                zeroRecords: "No items matched the search criteria"
            },
            subTemplates: {
                header: new PJQ.templating.Template(PJQ.constants.modules.PUNCHLISTS, 'Data-Table-Header-Punch-List')
            },
            pageLength: userSettings != null ? userSettings.rowsPerPage : 50,
            orderCookie: PJQ.constants.cookies.PUNCHLIST_ORDER_COOKIE,
            settings: this.options.userSettings.getSettings(PJQ.constants.punchlists.view.PUNCHLISTS),
            headerData: function () {
                return {
                    project: self.options.project,
                    preferences: self.preferences
                };
            },
            afterHeaderRender: _.bind(function (view, $header) {
                new PJQ.inputs.Selectpicker({
                    el: $header.find('.punch-list-filter'),
                    onChange: function (value) {
                        view.setFilter('primary', value);
                    },
                    isGrouped: true,
                    isIntChoices: true,
                    isMultiple: true,
                    noneSelectedText: 'No Filters'
                });

                if (this.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_LOCATIONS)) {
                    this.locationFilterPicker = new PJQ.inputs.ProjectLocationPicker({
                        el: this.$('.filter-location'),
                        project: this.options.project,
                        isMultiple: true,
                        onChange: _.bind(function (value) {
                            view.setFilter('location', value);
                        }, this)
                    });
                }
            }, this),
            getFilterData: function (view, data) {
                let result = data,
                    locationFilter = view.getFilter('location');
                if (_.size(locationFilter) > 0) {
                    result = _.filter(data, function (row) {
                        return _.contains(locationFilter, row.get('locationId'));
                    }, this);
                }

                let primaryFilter = view.getFilter('primary');
                if (_.size(primaryFilter) === 0) {
                    return result;
                }

                let statusFilter = primaryFilter.status,
                    priorityFilter = primaryFilter.priority,
                    hasAssigned = _.contains(statusFilter, PJQ.constants.punchlists.statuses.ASSIGNED);
                return _.filter(result, function (row) {
                    let rowStatus = row.get('status');
                    return (_.size(priorityFilter) === 0 || _.contains(priorityFilter, row.get('priority')))
                        && (_.size(statusFilter) === 0 || (hasAssigned && rowStatus === PJQ.constants.punchlists.statuses.NEW && row.assignedTo != null) || _.contains(statusFilter, rowStatus));
                });
            },
            order: [[0, "asc"]],
            deferRender: true,
            onRowDoubleClick: _.bind(function (row) {
                this.editPunchlistItem(row.data());
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            this.editPunchlistItem(row.data());
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: _.bind(function () {
                            return this.options.isAdmin;
                        }, this),
                        onClick: _.bind(function (row) {
                            this.deletePunchlistItem(row);
                        }, this)
                    }
                ]
            },
            columns: this.getColumns(false),
            colReorder: {
                fixedColumnsLeft: 0,
                fixedColumnsRight: 1,
                realtime: false
            },
            columnOrderChanged: _.bind(function () {
                if (this.options.userSettings != null) {
                    this.options.userSettings.save();
                }
            }, this)
        });
    },
    getColumns(includeAllColumns = false) {
        let columns = [], includeColumns = [],
            viewSettings = this.options.userSettings.getSettings(PJQ.constants.punchlists.view.PUNCHLISTS);

        if (includeAllColumns || viewSettings == null) {
            includeColumns = ["createdBy", "status", "priority", "itemNumber", "title", "assignedTo", "ballInCourt", "groupList", "category", "location", "dueDate"];

            if (_.size(this.options.customFields) > 0) {
                _.each(this.options.customFields.models, function (customField) {
                    includeColumns.push('fieldValue' + customField.get('fieldNumber'));
                });
            }
        } else
            includeColumns = viewSettings.columns;

        _.each(includeColumns, _.bind(function (column) {
                switch (column) {
                    case "createdBy":
                        columns.push({
                            columnData: 'createdBy',
                            title: "Created By",
                            render: function (data, type, row) {
                                return PJQ.helpers.contacts.getContactAnchor({contact: row.createdBy});
                            },
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : false
                        });
                        break;
                    case "status":
                        columns.push({
                            columnData: "status",
                            data: "attributes.status",
                            title: "Status",
                            width: "80px",
                            render: function (data, type, row) {
                                return '<span style="color:' + row.getStatusColor() + '">' + row.getStatusName() + '</span>';
                            },
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : true
                        });
                        break;
                    case "priority":
                        columns.push({
                            columnData: "priority",
                            data: "attributes.priority",
                            title: "Priority",
                            width: "40px",
                            render: function (data, type, row) {
                                return '<span style="color:' + row.getPriorityColor() + '">' + row.getPriorityName() + '</span>';
                            },
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : true
                        });
                        break;
                    case "itemNumber":
                        columns.push({
                            data: "attributes.itemNumber",
                            columnData: "itemNumber",
                            "render": (data, type, row) => {
                                if (type === 'sort' || type === 'type') {
                                    return data;
                                }

                                return '<a href="javascript:void(0)" class="btn-edit-punchlist-item">' + data + '</a>';
                            },
                            title: "Number",
                            width: "60px",
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : true
                        });
                        break;
                    case "title":
                        columns.push({
                            columnData: "title",
                            data: "attributes.title",
                            title: "Title",
                            width: "20%",
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : true
                        });
                        break;
                    case "assignedTo":
                        columns.push({
                            columnData: "assignedTo",
                            data: "attributes.assignedTo",
                            title: "Assigned To",
                            render: function (data, type, row) {
                                let result = 'Nobody';
                                if (row.assignedTo) {
                                    result = PJQ.helpers.contacts.getContactAnchor({contact: row.assignedTo});
                                }
                                return result;
                            },
                            width: "20%",
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : true
                        });
                        break;
                    case "ballInCourt":
                        columns.push({
                            columnData: "ballInCourt",
                            title: "Ball In Court",
                            render: function (data, type, row) {
                                let result = 'Nobody';

                                if ((row.get('status') === PJQ.constants.punchlists.statuses.NEW || row.get('status') === PJQ.constants.punchlists.statuses.NOT_RESOLVED) && row.assignedTo != null) {
                                    result = PJQ.helpers.contacts.getContactAnchor({contact: row.assignedTo});
                                } else if (row.get('status') === PJQ.constants.punchlists.statuses.WORK_COMPLETED) {
                                    result = 'Project Managers';
                                }

                                return result;
                            },
                            width: "20%",
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : false
                        });
                        break;
                    case 'groupList':
                        columns.push({
                            columnData: 'groupList',
                            title: "Trades",
                            render: function (data, type, row) {
                                let result = [];
                                if (_.size(row.groups.models) > 0) {
                                    _.each(row.groups.models, function (group) {
                                        result.push(group.get('groupName'));
                                    });
                                } else {
                                    result.push('None');
                                }
                                return result.join(', ');
                            },
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : false
                        });
                        break;
                    case 'category':
                        columns.push({
                            columnData: 'category',
                            data: "attributes.category",
                            title: "Category",
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : false
                        });
                        break;
                    case 'location':
                        columns.push({
                            columnData: 'location',
                            data: "attributes.location",
                            title: "Location",
                            render: _.bind(function (data, type, row) {
                                if (this.locations != null && this.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_LOCATIONS)) {
                                    let location = this.locations.get(row.get('locationId'));
                                    return location ? this.locations.getFullName(location) : '';
                                }
                                return data;
                            }, this),
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : false
                        });
                        break;
                    case "dueDate":
                        columns.push({
                            columnData: "dueDate",
                            "data": "attributes.dueDate",
                            "title": "Due",
                            "searchable": false,
                            "width": "80px",
                            "render": function (data, type, row) {
                                if (data != null) {
                                    let itemDueDate = new Date(data),
                                        dateString = PJQ.helpers.dateHelpers.getDateString(itemDueDate, PJQ.helpers.dateHelpers.dateFormats.DATE);
                                    if (row.get('status') !== PJQ.constants.punchlists.statuses.RESOLVED && PJQ.helpers.dateHelpers.getDateDaysDiff(itemDueDate, new Date()) < 0) {
                                        return '<span class="text-danger font-weight-bold">' + dateString + '</span>';
                                    }
                                    return dateString;
                                }
                                return 'Not Set';
                            },
                            visible: viewSettings != null ? viewSettings.columns.indexOf(column) !== -1 : true
                        });
                        break;
                    default:
                        if (column.startsWith('fieldValue')) {
                            _.each(this.options.customFields.models, function (customField) {
                                if (column === 'fieldValue' + customField.get('fieldNumber')) {
                                    columns.push({
                                        "columnData": 'fieldValue' + customField.get('fieldNumber'),
                                        "title": customField.get('fieldName'),
                                        "className": [PJQ.constants.commitments.customFieldType.INTEGER, PJQ.constants.commitments.customFieldType.MONEY, PJQ.constants.commitments.customFieldType.PERCENT].indexOf(customField.get('fieldTypeId')) !== -1 ? "text-align-right" : "",
                                        'visible': viewSettings.columns.indexOf(column) !== -1,
                                        "render": function (data, type, row) {
                                            let fieldValue = row.getCustomFieldValue(customField.get('id'));
                                            fieldValue = (fieldValue !== null) ? fieldValue : '';
                                            switch (customField.get('fieldType')) {
                                                case PJQ.constants.customFields.fieldTypes.TEXT:
                                                    if (fieldValue && type !== 'sort' && type !== 'type') {
                                                        if (PJQ.helpers.urlHelpers.isURL(fieldValue))
                                                            fieldValue = '<a target="_blank" href="' + fieldValue + '">' + fieldValue + '</a>';
                                                    }
                                                    break
                                                case 'BOOL':
                                                    if (fieldValue != null)
                                                        fieldValue = fieldValue ? 'Yes' : 'No';
                                                    break;
                                                case 'CHOICE':
                                                    let choices = [];
                                                    // convert single choice value into array so that the logic below can work for both types.
                                                    if (typeof fieldValue === 'number')
                                                        fieldValue = [fieldValue];

                                                    _.each(customField.choices.models, _.bind(function (choice) {
                                                        if (_.find(fieldValue, function (value) {
                                                            return value === choice.get('id');
                                                        }))
                                                            choices.push(choice.get('choiceName'));
                                                    }, this));

                                                    fieldValue = choices.join((', '));
                                                    break;
                                                case 'DATE':
                                                    if (fieldValue) {
                                                        if (type !== 'sort' && type !== 'type')
                                                            fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                                                    }
                                                    if (fieldValue === undefined)
                                                        fieldValue = '';

                                                    break;
                                                case 'DATETIME':
                                                    if (fieldValue) {
                                                        if (type !== 'sort' && type !== 'type')
                                                            fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, false);
                                                    }
                                                    if (fieldValue === undefined)
                                                        fieldValue = '';

                                                    break;
                                                case 'INT':
                                                    if (type !== 'sort' && type !== 'type' && fieldValue) {
                                                        fieldValue = parseInt(fieldValue).toLocaleString();
                                                    }
                                                    break;
                                                case 'MONEY':
                                                    if (type === 'sort' || type === 'type') {
                                                        if (fieldValue && fieldValue !== '$')
                                                            fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                                                        else
                                                            fieldValue = 0;
                                                    } else {
                                                        fieldValue = PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)));
                                                    }
                                                    break;
                                                case 'PERCENT':
                                                    if (type === 'sort' || type === 'type') {
                                                        if (!fieldValue)
                                                            fieldValue = 0;
                                                    } else {
                                                        fieldValue = fieldValue ? PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)), 2, false) + '%' : '';
                                                    }
                                                    break;
                                            }

                                            return fieldValue;
                                        }
                                    });
                                }
                            });
                        }
                        break;
                }
            }, this)
        );

        if (!includeAllColumns) {
            columns.push({
                columnData: "punchlistItemId",
                data: "attributes.punchlistItemId",
                title: "",
                width: '100px',
                orderable: false,
                searchable: false,
                resizable: false,
                className: 'text-align-center',
                render: _.bind(function (data) {
                    let html = '<div class="show-on-row-hover" style="min-width:80px;"><button type="button" data-punchlist-id="' + data + '" class="btn btn-info btn-edit-punchlist-item"><i class="fal fa-pencil"></i></button>';
                    if (this.options.isAdmin) {
                        html += '<button type="button" data-punchlist-id="' + data + '" class="btn btn-danger btn-delete-punchlist-item ml-1"><i class="fal fa-trash"></i></button>';
                    }
                    html += '</div>';
                    return html;
                }, this)
            });
        }

        return columns;
    },
    addClicked() {
        let newItem = new PJQ.models.punchlists.PunchlistItem({
            projectId: this.options.project ? this.options.project.id : null,
            templateId: this.model != null ? this.model.get('templateId') : null
        });
        this.editPunchlistItem(newItem);
    },
    editClicked(e) {
        let row = this.punchlistDataTable.getRow($(e.currentTarget).parents('tr'));
        this.editPunchlistItem(row.data());
    },
    editPunchlistItem: function (item) {
        let isNew = item.isNew();
        let fnRenderEditor = _.bind(function () {
            new PJQ.views.punchlists.PunchlistItemEditorModal({
                model: item,
                collection: this.collection,
                project: this.options.project,
                onSave: _.bind(function (item) {
                    if (isNew) {
                        this.punchlistDataTable.addRow(item);
                        this.collection.add(item);
                    }
                    this.punchlistDataTable.refresh();
                }, this),
                onClose: _.bind(function (item) {
                    if (item.hasChanged()) {
                        item.restore();
                    }
                }, this),
                onDelete: _.bind(function (item) {
                    if (item.id > 0) {
                        let row = this.punchlistDataTable.getRow(item.cid);
                        if (row != null) {
                            this.punchlistDataTable.removeRow(row);
                        }
                    }
                    item.destroy();
                }, this)
            });
        }, this)
        if (!item.isNew()) {
            item.fetch({
                success: _.bind(function () {
                    fnRenderEditor();
                }, this)
            });
        } else {
            fnRenderEditor();
        }
    },
    deleteClicked(e) {
        let row = this.punchlistDataTable.getRow($(e.currentTarget).parents('tr'));
        this.deletePunchlistItem(row);
    },
    deletePunchlistItem: function (row) {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this punch list item?",
            onDelete: _.bind(function () {
                row.data().destroy();
                this.punchlistDataTable.removeRow(row);
            }, this)
        });
    },
    exportList: function (e) {
        if (this.options.project == null) {
            return;
        }

        let $target = $(e.currentTarget),
            type = $target.data('type'),
            filters = {},
            primaryFilter = this.punchlistDataTable.getFilter('primary');
        if (_.size(primaryFilter) > 0) {
            let statusFilter = primaryFilter.status,
                priorityFilter = primaryFilter.priority,
                hasAssigned = _.contains(statusFilter, PJQ.constants.punchlists.statuses.ASSIGNED);

            if (_.size(statusFilter) > 0) {
                filters.statuses = statusFilter;
            }

            if (_.size(priorityFilter) > 0) {
                filters.priority = priorityFilter;
            }
        }

        let orderCookie = PJQ.helpers.cookieHelpers.getCookie(PJQ.constants.cookies.PUNCHLIST_ORDER_COOKIE),
            order = orderCookie != null ? JSON.parse(orderCookie) : null,
            report = new PJQ.models.reports.NewReport({
                type: PJQ.constants.reports.reportTypes.PUNCH_LIST.type,
                projectId: this.options.project ? this.options.project.id : null,
                options: {
                    filters: filters,
                    columns: this.options.userSettings.getSettings(PJQ.constants.punchlists.view.PUNCHLISTS).columns,
                    columnOrder: order
                }
            });
        report.export({format: type}).then(() => {

        });
    },
    exportDetailedList: function () {
        if (this.options.project == null) {
            return;
        }

        let params = [
                {
                    parameter: 'orderBy',
                    value: this.punchlistDataTable.options.settings.orderBy
                },
                {
                    parameter: 'orderAscending',
                    value: this.punchlistDataTable.options.settings.orderAscending
                }
            ],
            filterData = this.punchlistDataTable.getFilteredRowData();
        if (_.size(filterData) < _.size(this.collection.models)) {
            params.push(
                {
                    parameter: 'ids',
                    value: _.map(filterData, function (item) {
                        return item.id;
                    })
                }
            );
        }

        let loader = new PJQ.Loader(this.$('.btn-export'), {
            loadingText: ""
        });
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'punchlists',
                },
                {
                    endpoint: 'export'
                },
                {
                    endpoint: 'detailed'
                }
            ], params),
            data: {
                itemOrder: _.map(filterData, (item) => {
                    return item.id
                })
            }
        }).post().done(_.bind(function (response) {
            PJQ.files.handleDownload(response);
            loader.remove();
        }, this)).fail(_.bind(function (xhr, err, result) {
            loader.remove();
        }, this));
    },
    viewPunchListSettings: function () {
        new PJQ.views.punchlists.PunchListSettingsModal({
            punchlistsView: this,
            project: this.options.project,
            userSettings: this.options.userSettings,
            onSave: _.bind(function () {
                this.renderDataTable();
            }, this)
        });
    },
    saveTemplate: function () {
        new PJQ.views.punchlists.PunchlistTemplateCreatorModal({
            collection: this.collection,
            project: this.options.project
        });
    },
    importTemplate: function () {
        new PJQ.views.punchlists.ImportTemplateModal({
            project: this.options.project,
            onImport: _.bind(function (submittals) {
                this.collection = submittals;
                this.render();
            }, this)
        });
    },
});

PJQ.views.punchlists.PunchlistItemEditorModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PUNCHLISTS, 'Modal-Punchlist-Item-Editor'),
        subTemplates: {
            comments: new PJQ.templating.Template(PJQ.constants.modules.PUNCHLISTS, 'Punchlist-Item-Comments'),
            contactBadge: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Contacts-Select-Input-Contacts')
        },
        width: '90%',
        maxWidth: 1200,
        isShowCloseButton: true,
        onSave: _.noop
    },
    events: {
        'click .add-comment': 'addComment',
        'click .item-cancel': 'cancel',
        'click .edit-history': 'viewEditHistory',
        'click .btn-notification-history': 'viewNotificationHistory',
        'click .btn-export': 'exportPDF',
        'click .item-status-not-resolved': 'markNotResolved',
        'click .item-status-work-completed': 'markWorkCompleted',
        'click .item-status-resolved': 'markResolved',
        'click .punchlist-save': 'save',
        'click .punchlist-close': 'close',
        'click .punchlist-delete': 'onDelete',
        'click .delete-comment': 'deleteComment',
        'click .btn-distribute': 'distribute'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        this.preferences = this.options.project ? this.options.project.preferences : PJQ.app.session.preferences;
        this.changedAnnotations = new PJQ.collections.drawings.Annotations();

        if (this.options.project != null) {
            this.options.customFields = await this.options.project.fetchPunchListCustomFields();
        } else {
            this.options.customFields = await PJQ.app.session.fetchPunchListCustomFields();
        }

        if (!this.model.isNew() && !this.model.isFetched) {
            await this.model.fetch();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        this.options.canEdit = true;
        this.options.canUpload = true;
        this.options.isAdmin = true;

        let isAssignee = this.model.get('isAssignee') || (this.model.assignedTo != null && (PJQ.app.session.contact != null && this.model.assignedTo.id === PJQ.app.session.contact.id || PJQ.app.session.user != null && this.model.assignedTo.id === PJQ.app.session.user.get('id')));
        if (this.options.project != null) {
            this.options.canEdit = this.model.isNew() || this.options.project.hasPermission('punchList.isAdmin') && this.model.get('status') !== PJQ.constants.punchlists.statuses.RESOLVED;
            this.options.canUpload = this.options.canEdit || isAssignee;
            this.options.isAdmin = PJQ.app.session.user != null && this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId') && this.options.project.hasPermission('punchList.isAdmin');
        }
    },
    renderData: function () {
        return {
            canEdit: this.options.canEdit,
            canUpload: this.options.canUpload,
            isAdmin: this.options.isAdmin,
            model: this.model,
            preferences: this.preferences,
            locations: this.locations
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.isSaving = false;
        if (this.options.canEdit) {
            new PJQ.Binder(this.$el, this.model, {
                watchElements: [
                    'input',
                    'textarea'
                ]
            });
        }

        new PJQ.inputs.Datepicker({
            el: this.$('.punch-list-due-date'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('dueDate')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('dueDate');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('dueDate', newDate);
                }
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.punch-list-priority'),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.model.set('priority', value);
            }, this),
            defaultValue: this.model.get('priority')
        });

        if (this.options.canEdit) {
            new PJQ.inputs.AutocompleteInput({
                el: this.$('input.item-category'),
                source: this.collection == null ? [] : _.map(_.filter(this.collection.models, _.bind(function (item) {
                    return _.size(item.get('category')) > 0 && item.id !== this.model.id;
                }, this)), function (item) {
                    return item.get('category');
                })
            });
        }

        if (this.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_LOCATIONS)) {
            new PJQ.inputs.ProjectLocationPicker({
                el: this.$('.select-location'),
                project: this.options.project,
                canEdit: this.options.canEdit,
                onChange: _.bind(function (value) {
                    this.model.set('locationId', value);
                }, this),
                defaultValue: this.model.get('locationId')
            });
        } else {
            new PJQ.inputs.AutocompleteInput({
                el: this.$('input.item-location'),
                source: this.collection == null ? [] : _.map(_.filter(this.collection.models, _.bind(function (item) {
                    return _.size(item.get('location')) > 0 && item.id !== this.model.id;
                }, this)), function (item) {
                    return item.get('location');
                })
            });
        }

        this.renderBallInCourt();

        this.renderCustomFields();

        new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.punchlist-assigned'),
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            selectedContact: this.model.assignedTo,
            isSingleChoice: true,
            isReadOnly: !this.options.canEdit || !this.options.isAdmin,
            onChange: _.bind(function (selectedContact) {
                this.model.assignedTo = selectedContact;
                this.renderBallInCourt();
                this.renderStatus();
            }, this)
        });

        if (this.options.isAdmin) {
            new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.punch-list-distribution-list'),
                selectedContact: this.model.distributionList.models,
                canViewContacts: this.options.project == null || this.options.project.hasPermission('projectContacts.canView'),
                canEdit: this.options.canEditPeople,
                displayContactsBlock: true,
                canSwitchContext: this.options.project == null,
                context: this.options.project != null ? PJQ.constants.contacts.contexts.PROJECTCONTACTS : PJQ.constants.contacts.contexts.USERS,
                isSingleChoice: false,
                onChange: _.bind(function (selectedContacts) {
                    this.model.distributionList.reset(selectedContacts);
                    this.model.isDirty = true;
                }, this)
            });
        }

        this.groupListInput = new PJQ.views.groups.GroupsSelectInput({
            el: this.$('.punchlist-groups'),
            isShowAddButton: false,
            addButton: this.$('.btn-edit-groups'),
            groupLevels: this.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS),
            groupUserId: this.options.project ? this.options.project.get('masterUserId') : null,
            selectedGroups: this.model.groups.models,
            isReadOnly: !this.options.canEdit,
            onAfterSave: _.bind(function (selectedGroups) {
                this.model.groups.reset(selectedGroups);
                this.model.isDirty = true;
            }, this)
        });

        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.punchlist-file-uploader'),
            context: 'punchlist',
            contextId: this.model.id,
            canAddAnnotations: this.options.canEdit,
            onAnnotationChange: this.model.id > 0 ? null : (annotation) => {
                this.changedAnnotations.merge(annotation);
            },
            mergeAnnotations: this.changedAnnotations,
            collection: this.model.attachments,
            includeProjectAttachments: true,
            previewImageDimension: 150,
            // includeProjectAttachments: true,
            canUpload: this.options.canUpload,
            canDelete: this.options.canEdit && this.options.isAdmin,
            onDelete: _.bind(function (attachment, callback) {
                if (attachment.id > 0) {
                    attachment.set('isDeleted', true);
                } else {
                    this.model.attachments.remove(attachment);
                }
                this.model.isDirty = true;
                callback();
            }, this)
        });

        this.beforeUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.punchlist-before-file-uploader'),
            context: 'punchlist',
            contextId: this.model.id,
            canAddAnnotations: this.options.canEdit,
            onAnnotationChange: this.model.id > 0 ? null : (annotation) => {
                this.changedAnnotations.merge(annotation);
            },
            mergeAnnotations: this.changedAnnotations,
            collection: this.model.beforeAttachments,
            includeProjectAttachments: true,
            offsetTopText: true,
            previewImageDimension: 150,
            // includeProjectAttachments: true,
            canUpload: this.options.canUpload,
            canDelete: this.options.canEdit && this.options.isAdmin,
            onDelete: _.bind(function (attachment, callback) {
                if (attachment.id > 0) {
                    attachment.set('isDeleted', true);
                } else {
                    attachment.destroy();
                }
                this.model.isDirty = true;
                callback();
            }, this)
        });

        this.afterUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.punchlist-after-file-uploader'),
            context: 'punchlist',
            contextId: this.model.id,
            canAddAnnotations: this.options.canEdit,
            onAnnotationChange: this.model.id > 0 ? null : (annotation) => {
                this.changedAnnotations.merge(annotation);
            },
            mergeAnnotations: this.changedAnnotations,
            collection: this.model.afterAttachments,
            includeProjectAttachments: true,
            offsetTopText: true,
            previewImageDimension: 150,
            // includeProjectAttachments: true,
            canUpload: this.options.canUpload,
            canDelete: this.options.canEdit && this.options.isAdmin,
            onDelete: _.bind(function (attachment, callback) {
                if (attachment.id > 0) {
                    attachment.set('isDeleted', true);
                } else {
                    attachment.destroy();
                }
                this.model.isDirty = true;
                callback();
            }, this)
        });

        this.renderComments();
    },
    renderStatus: function () {
        this.$('.punch-list-status').css('background-color', this.model.getStatusColor());
        this.$('.punch-list-status-name').html(this.model.getStatusName());
    },
    renderBallInCourt: function () {
        let $ballInCourt = this.$('.punch-list-ball-in-court');
        if ((this.model.get('status') === PJQ.constants.punchlists.statuses.NEW || this.model.get('status') === PJQ.constants.punchlists.statuses.NOT_RESOLVED) && this.model.assignedTo != null) {
            this.renderSubTemplate(false, this.options.subTemplates.contactBadge, $ballInCourt,
                {
                    models: [this.model.assignedTo],
                    isReadOnly: true,
                    canEdit: false,
                    canView: false
                });
        } else if (this.model.get('status') === PJQ.constants.punchlists.statuses.WORK_COMPLETED) {
            $ballInCourt.html('<div class="text-muted font-weight-light mt-1">Project Managers</div>');
        } else {
            new PJQ.Alert($ballInCourt, {
                type: 'warning',
                text: 'The ball in court will set automatically'
            });
        }
    },
    renderCustomFields: function () {
        this.customFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
            el: this.$('.punchlist-custom-fields'),
            collection: this.options.customFields,
            fieldValues: this.model.get('customFieldValues'),
            isEdit: this.options.canEdit
        });
    },
    distribute: function () {
        new PJQ.views.modals.YesNo({
            header: "Distribute Punch List Item?",
            body: 'Are you sure you want to distribute this punch list item?',
            onYes: () => {
                this.model.distribute(() => {
                    PJQ.notifications.notify.successNotify({
                        message: "Punch List Item successfully distributed"
                    });
                    this.render();
                });
            }
        });
    },
    exportPDF: function () {
        let loader = new PJQ.Loader(this.$('.btn-export'), {
            loadingText: ""
        });
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.id
                },
                {
                    endpoint: 'punchlists',
                    value: this.model.id
                },
                {
                    endpoint: 'export'
                },
                {
                    endpoint: 'pdf'
                }
            ])
        }).get().done(_.bind(function (response) {
            PJQ.files.handleDownload(response);
            loader.remove();
        }, this)).fail(_.bind(function (xhr, err, result) {
            loader.remove();
        }, this));
    },
    addComment: function () {
        let val = this.$('.item-new-comment').val().trim();
        if (_.size(val) === 0)
            return;

        let comment = new PJQ.models.punchlists.PunchlistItemComment({
            punchlistItemId: this.model.id,
            commentText: val,
            createdOn: new Date()
        });
        if (!this.model.isNew()) {
            comment.save(null, {
                success: _.bind(function () {
                    this.model.comments.add(comment);
                    this.renderComments();
                }, this)
            });
        } else {
            comment.createdBy = PJQ.app.session.user;
            this.model.comments.add(comment);
            this.renderComments();
        }

        this.$('.item-new-comment').val('');
    },
    renderComments: function () {
        this.renderSubTemplate(false, this.options.subTemplates.comments, this.$('.item-comments'), {
            comments: this.model.comments.models,
            canDelete: PJQ.app.session.hasPermission('punchList.isAdmin') || (this.options.project && this.options.project.hasPermission('punchList.isAdmin'))
        });
    },
    deleteComment: function (e) {
        let cid = $(e.currentTarget).data('cid'), commentId = $(e.currentTarget).data('commentId'),
            card = $(e.currentTarget).closest('div.card');
        new PJQ.views.BaseModal({
            header: "Confirm Delete Comment",
            body: "Are you sure you want to delete this comment?",
            isShowCancelButton: true,
            okButtonText: "Confirm",
            onOk: _.bind(function () {
                let comments = _.filter(this.model.comments.models, _.bind(function (comment, i) {
                    return (comment.cid === cid);
                }, this));

                if (_.size(comments) > 0) {
                    comments[0].set('deletedOn', new Date());
                    if (!comments[0].isNew()) {
                        comments[0].destroy();
                    }
                }

                _.each(this.model.get('comments'), _.bind(function (comment, i) {
                    if (comment.commentId === commentId) {
                        this.model.get('comments')[i].deletedOn = new Date();
                    }
                }, this));

                card.hide();
            }, this)
        });
    },
    markNotResolved: function () {
        new PJQ.views.BaseModal({
            header: "Confirm Status Change",
            body: "Are you sure you want to mark this Punch List Item as <span class='text-danger'>Not Resolved</span>?",
            isShowCancelButton: true,
            okButtonText: "Confirm",
            onOk: _.bind(function () {
                this.model.set('status', PJQ.constants.punchlists.statuses.NOT_RESOLVED);
                this.save();
            }, this)
        });
    },
    markWorkCompleted: function () {
        let workCompleteOverride = this.preferences.getPref(PJQ.constants.preferenceTypes.PUNCH_LIST_WORK_COMPLETED_STATUS_OVERRIDE);
        new PJQ.views.BaseModal({
            header: "Confirm Status Change",
            body: "Are you sure you want to mark this Punch List Item as <span class='text-primary'>" + (workCompleteOverride ? workCompleteOverride : "Work Completed") + "</span>?",
            isShowCancelButton: true,
            okButtonText: "Confirm",
            onOk: _.bind(function () {
                this.model.set('status', PJQ.constants.punchlists.statuses.WORK_COMPLETED);
                this.save();
            }, this)
        });
    },
    markResolved: function () {
        new PJQ.views.BaseModal({
            header: "Confirm Status Change",
            body: "Are you sure you want to mark this Punch List Item as <span class='text-success'>Resolved</span>?",
            isShowCancelButton: true,
            okButtonText: "Confirm",
            onOk: _.bind(function () {
                this.model.set('status', PJQ.constants.punchlists.statuses.RESOLVED);
                this.save();
            }, this)
        });
    },
    validate: function () {
        let isValid = true;

        PJQ.helpers.inputHelpers.setInputError(this.$('.item-title'), true);
        if (_.size(this.$('.item-title').val()) === 0) {
            isValid = false;
            PJQ.helpers.inputHelpers.setInputError(this.$('.item-title'), false);
        }

        isValid = isValid && this.customFieldsForm.validate();

        // display/clear banner on top of page
        if (!isValid) {
            new PJQ.Alert(this.$('.validation-error'), {
                type: 'danger',
                text: 'Required fields are empty'
            });

            window.scrollTo(0, 0);
        } else {
            this.$('.validation-error').empty();
        }

        return isValid;
    },
    viewEditHistory: function () {
        new PJQ.views.punchlists.EditHistoryModal({
            collection: this.model.editHistory
        });
    },
    viewNotificationHistory: function () {
        this.model.fetchNotifications(function (notifications) {
            new PJQ.views.notifications.NotificationHistory({
                collection: notifications
            });
        })
    },
    save: function () {
        if (this.isSaving) {
            return;
        }
        this.isSaving = true;

        this.model.set('groups', this.groupListInput.selectedGroups);
        if (!this.validate()) {
            this.isSaving = false;
            return;
        }

        if (this.fileUploader.isUploading()) {
            new PJQ.views.BaseModal({
                header: "Files Uploading",
                body: "You can't save while files are uploading"
            });
            this.isSaving = false;
            return;
        }

        let fnSaveAnnotations = (callback) => {
                if (_.size(this.changedAnnotations.models) === 0) {
                    callback();
                    return;
                }

                _.each(this.changedAnnotations.models, (annotation) => {
                    if (annotation.isNew()) {
                        annotation.set('contextId', this.model.id);
                    }
                });
                this.changedAnnotations.saveAll(() => {
                    if (this.options.isAdmin) {
                        this.model.set('isRead', true);
                    }
                    callback();
                });
            },
            isNew = this.model.isNew();
        if (this.model.hasChanged() || isNew) {
            this.model.save(null, {
                notify: true,
                success: () => {
                    fnSaveAnnotations(() => {
                        if (typeof this.options.onSave === 'function') {
                            this.options.onSave(this.model);
                        }

                        this.removeModal();
                    });
                }
            });
        } else {
            fnSaveAnnotations(() => {
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                PJQ.notifications.notify.successNotify({
                    message: "Punch List Item Saved Successfully"
                });

                this.removeModal();
            });
        }
    },
    close: function () {
        if (this.options.canEdit && this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.onClose(this.model);
                    this.removeModal();
                }, this)
            });
        } else {
            this.onClose(this.model);
            this.removeModal();
        }
    },
    onDelete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this punch list item?",
            onDelete: _.bind(function () {
                if (this.options.onDelete) {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});

PJQ.views.punchlists.EditHistoryModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PUNCHLISTS, 'Modal-Punchlist-History'),
        minWidth: 700
    },
    afterRender: function () {
        this.$('.modal-header span').text(this.options.context + ' History');

        let columns = [
            {data: "createdOnDisplay", title: "Changed"},
            {data: "createdByDisplay", title: "Changed By"},
            {data: "attributes.fieldNameDisplay", title: "Field Name"},
            {data: "oldValueDisplay", title: "Old Value"},
            {data: "newValueDisplay", title: "New Value"}
        ];

        this.dataTable = this.$('.history-table').DataTable({
            data: this.collection.models,
            language: {
                zeroRecords: "No history found"
            },
            columns: columns,
            dom: '<"top"p>rt<"bottom"p><"clear">'
        });
    },
    events: {
        "click .history-close": "close"
    },
    close: function () {
        this.removeModal();
    }
});

PJQ.views.punchlists.PunchListSettingsModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PUNCHLISTS, 'Modal-Punch-List-Settings'),
		subTemplates: {},
		maxWidth: 500,
		onSave: _.noop
	},
	events: {
		'change .select-column': 'columnSelected',
		'click .settings-save': 'onSave',
		'click .btn-delete-punch-lists': 'deleteItems'
	},
	afterModalCreated: function () {
		new PJQ.Loader(this.$('.modal-body'));
		PJQ.app.session.project.fetchProjectContacts(_.bind(function(projectContacts){
			this.projectContacts = projectContacts;
			PJQ.app.session.project.fetchPunchListSettings(_.bind(function (settings) {
				this.model = settings;
				this.render();
			}, this));
		}, this))
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model,
			project: this.options.project
		};
	},
	afterRender: function () {
		if(this.model){
			new PJQ.views.contacts.ContactsSelectInput({
				el: this.$('.punch-list-creators'),
				contacts: this.projectContacts,
				selectedContact: this.model.projectContacts.filter(function(projectContact){
					return projectContact.get('canAdd');
				}),
				isSingleChoice: false,
				onAdd: _.bind(function (contacts) {
					this.updateProjectContactsSetting(contacts, 'canAdd', true);
				}, this),
				onDelete: _.bind(function (contact) {
					this.updateProjectContactsSetting(contact, 'canAdd', false);
				}, this)
			});

			new PJQ.views.contacts.ContactsSelectInput({
				el: this.$('.punch-list-notify-created'),
				contacts: this.projectContacts,
				selectedContact: this.model.projectContacts.filter(function(projectContact){
					return projectContact.get('notifyAdded');
				}),
				isSingleChoice: false,
				onAdd: _.bind(function (contacts) {
					this.updateProjectContactsSetting(contacts, 'notifyAdded', true);
				}, this),
				onDelete: _.bind(function (contact) {
					this.updateProjectContactsSetting(contact, 'notifyAdded', false);
				}, this)
			});

			new PJQ.views.contacts.ContactsSelectInput({
				el: this.$('.punch-list-notify-comment'),
				contacts: this.projectContacts,
				selectedContact: this.model.projectContacts.filter(function(projectContact){
					return projectContact.get('notifyComment');
				}),
				isSingleChoice: false,
				onAdd: _.bind(function (contacts) {
					this.updateProjectContactsSetting(contacts, 'notifyComment', true);
				}, this),
				onDelete: _.bind(function (contact) {
					this.updateProjectContactsSetting(contact, 'notifyComment', false);
				}, this)
			});


			new PJQ.views.contacts.ContactsSelectInput({
				el: this.$('.punch-list-notify-work-completed'),
				contacts: this.projectContacts,
				selectedContact: this.model.projectContacts.filter(function(projectContact){
					return projectContact.get('notifyWorkCompleted');
				}),
				isSingleChoice: false,
				onAdd: _.bind(function (contacts) {
					this.updateProjectContactsSetting(contacts, 'notifyWorkCompleted', true);
				}, this),
				onDelete: _.bind(function (contact) {
					this.updateProjectContactsSetting(contact, 'notifyWorkCompleted', false);
				}, this)
			});

			new PJQ.views.contacts.ContactsSelectInput({
				el: this.$('.punch-list-notify-not-resolved'),
				contacts: this.projectContacts,
				selectedContact: this.model.projectContacts.filter(function(projectContact){
					return projectContact.get('notifyNotResolved');
				}),
				isSingleChoice: false,
				onAdd: _.bind(function (contacts) {
					this.updateProjectContactsSetting(contacts, 'notifyNotResolved', true);
				}, this),
				onDelete: _.bind(function (contact) {
					this.updateProjectContactsSetting(contact, 'notifyNotResolved', false);
				}, this)
			});

			new PJQ.views.contacts.ContactsSelectInput({
				el: this.$('.punch-list-notify-resolved'),
				contacts: this.projectContacts,
				selectedContact: this.model.projectContacts.filter(function(projectContact){
					return projectContact.get('notifyResolved');
				}),
				isSingleChoice: false,
				onAdd: _.bind(function (contacts) {
					this.updateProjectContactsSetting(contacts, 'notifyResolved', true);
				}, this),
				onDelete: _.bind(function (contact) {
					this.updateProjectContactsSetting(contact, 'notifyResolved', false);
				}, this)
			});

			this.rowsPerPageSelectPicker = new PJQ.inputs.Selectpicker({
				el: this.$('.rows-per-page'),
				defaultValue: this.options.userSettings.getSettings(PJQ.constants.punchlists.view.PUNCHLISTS).rowsPerPage,
				onChange: _.bind(function (value) {
					this.onChange();
				}, this)
			});

			this.dataTable = new PJQ.views.dataTables.DataTable({
				el: this.$('div.column-settings'),
				data: this.options.punchlistsView.getColumns(true),
				isHideSearch: true,
				order: [],
				columns: [
					{"data": "title", "title": "Column", "orderable": false},
					{
						"data": "visible",
						"title": "Show",
						"orderable": false,
						"searchable": false,
						"render": _.bind(function (data) {
							return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-column"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
						}, this),
						"width": '10%'
					}
				],
				dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
			});

		}
	},
	deleteItems: function() {
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete all punch list items on this project?",
			onDelete: _.bind(function () {
				this.options.project.deleteAllPunchLists(_.bind(function () {
					this.options.punchlistsView.collection.remove(this.options.punchlistsView.collection.models);
					if (typeof this.options.onSave === 'function') {
						this.options.onSave(this.model);
					}
					this.removeModal();
				}, this));
			}, this)
		});
	},
	columnSelected: function (sender) {
		this.dataTable.dataTable.row($(sender.currentTarget).closest('tr')).data().visible = $(sender.currentTarget).prop('checked');
	},
	updateProjectContactsSetting: function(contacts, setting, value){
		contacts = PJQ.helpers.objectHelpers.refinedType(contacts) === 'array' ? contacts : [contacts];
		_.each(contacts, _.bind(function(contact){
			let existingSetting = this.model.projectContacts.findWhere({ id: contact.id });
			if(existingSetting != null){
				existingSetting.set(setting, value);
			}
			else{
				let newSetting = new PJQ.models.punchlists.ProjectContactSetting(contact.attributes);
				newSetting.set(setting, value);
				this.model.projectContacts.add(newSetting);
			}
		}, this));
	},
	onSave: function () {
		let loader = new PJQ.Loader(this.$('.modal-content'));

		this.options.punchlistsView.options.userSettings.getSettings(PJQ.constants.punchlists.view.PUNCHLISTS).rowsPerPage = parseInt(this.rowsPerPageSelectPicker.getValue());
		let columns = this.options.punchlistsView.options.userSettings.getSettings(PJQ.constants.punchlists.view.PUNCHLISTS).columns;
		_.each(this.dataTable.dataTable.data(), function (row) {
			if (row.visible) {
				if (columns.indexOf(row.columnData) === -1)
					columns.push(row.columnData);
			}
			else {
				columns = _.filter(columns, function(column) {
					return (column != row.columnData);
				});
			}
		});
		this.options.punchlistsView.options.userSettings.getSettings(PJQ.constants.punchlists.view.PUNCHLISTS).columns = columns;

		this.options.punchlistsView.options.userSettings.save(null, {
			success: _.bind(function() {
				this.model.put(null, {
					success: _.bind(function () {
						this.options.onSave();
						this.removeModal();
					}, this),
					error: function () {
						loader.remove();
					}
				});
			}, this)
		});
	}
});
PJQ.views.punchlists.PunchlistTemplateCreatorModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PUNCHLISTS, 'modal-create-template'),
        width: '30%'
    },
    events: {
        'click .btn-save' : 'save'
    },
    beforeModalCreated: function () {
        this.model = new PJQ.models.punchlists.Template({
            projectId: this.options.project.id
        });

        this.options.project.fetchPunchlistTemplates(_.bind(function (tmp) {
            this.templates = tmp;
            this.render();
        }, this));
    },
    renderData: function () {
        return {
            templates: this.templates,
            punchlists: this.collection
        };
    },
    afterRender: function () {
        if (this.templates != null && this.templates.isFetched) {
            new PJQ.inputs.Selectpicker({
                el: this.$('.select-punchlist'),
                isMultiple: true,
                noneSelectedText: 'Select Punchlist #',
                onChange: _.bind(function (value) {

                }, this)
            });

            new PJQ.inputs.AutocompleteInput({
                el: this.$('.input-template-name'),
                source: _.map(this.templates.models, function (template) {
                    return template.get('name')
                })
            });
        }
    },
    save: function () {
        let $name = this.$('.input-template-name'),
            name = $name.val();
        if (_.size(name.trim()) === 0) {
            PJQ.helpers.inputHelpers.setInputError($name);
            return;
        }
        else {
            PJQ.helpers.inputHelpers.setInputError($name, true);
        }

        let existingTemplate = this.templates.findWhere({name: name}),
            fnSave = _.bind(function () {
                this.model.set({
                    name: name,
                    copyComments: this.$('.input-copy-comments').prop('checked'),
                    copyAssignee: this.$('.input-copy-assignee').prop('checked'),
                    copyGroups: this.$('.input-copy-trades').prop('checked')
                });
                this.model.save(null, {
                    success: _.bind(function () {
                        this.removeModal();
                        PJQ.notifications.notify.successNotify({
                            message: 'Punchlist Template Created'
                        });
                    }, this)
                });
            }, this);
        if (existingTemplate != null) {
            new PJQ.views.modals.YesNo({
                header: "Overwrite Template",
                body: "A template already exists with this name.  Would you like to overwrite it?",
                onYes: _.bind(function () {
                    this.model.set('templateId', existingTemplate.id);
                    fnSave();
                }, this)
            });
        }
        else {
            fnSave();
        }
    }
});

PJQ.views.punchlists.ImportTemplateModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PUNCHLISTS, 'modal-import-template'),
        maxWidth: 500,
        onImport: null
    },
    events: {
        'click .btn-import': 'save'
    },
    beforeModalCreated: function () {
        this.options.project.fetchPunchlistTemplates(_.bind(function (tmp) {
            this.templates = tmp;
            this.render();
        }, this));
    },
    renderData: function () {
        return {
            templates: this.templates
        };
    },
    afterRender: function () {
        if (this.templates != null && this.templates.isFetched) {
            this.templatePicker = new PJQ.inputs.Selectpicker({
                el: this.$('.select-template'),
                onChange: _.bind(function (value) {
                    this.selectedTemplate = this.templates.get(value);
                }, this),
                isIntChoices: true,
                noneSelectedText: 'Select Template'
            });

        }
    },
    save: function () {
        let isValid = true;
        if (this.selectedTemplate == null) {
            this.templatePicker.showError();
            isValid = false;
        }
        else {
            this.templatePicker.hideError();
        }


        if (!isValid) {
            return;
        }

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'punchlists'
                },
                {
                    endpoint: 'import',
                    value: this.selectedTemplate.id
                }
            ], [
                {
                    parameter: 'importComments',
                    value: this.$('.input-import-comments').prop('checked')
                },
                {
                    parameter: 'importAssignee',
                    value: this.$('.input-import-assignee').prop('checked')
                },
                {
                    parameter: 'importGroups',
                    value: this.$('.input-import-trades').prop('checked')
                },
                {
                    parameter: 'importAttachments',
                    value: this.$('.input-import-attachments').prop('checked')
                }
            ])
        }).put().done(_.bind(function (response) {
            if (typeof this.options.onImport === 'function') {
                let result = new PJQ.collections.punchlists.PunchlistItems(response);
                result.isFetched = true;
                this.options.onImport(result);
            }
            this.removeModal();
            PJQ.notifications.notify.successNotify({
                message: 'Punchlist Template Imported'
            });
        }, this));
    }
});

PJQ.views.punchlists.EditTemplateModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PUNCHLISTS, 'Modal-Edit-Template'),
        maxWidth: '90%',
        fitHeight: true,
        onClose: null
    },
    events: {
        'click .btn-close': 'close',
        'click .btn-delete': 'deleteTemplate'
    },
    beforeModalCreated: function () {
        this.listenTo(this.model, 'fetch', this.render);
        this.model.fetch();
    },
    renderData: function () {
        return {
            model: this.model
        };
    },
    afterRender: function () {
        if (this.model.isFetched) {

            new PJQ.inputs.TextEditorInput({
                el: this.$('.edit-template-name'),
                label: 'Name',
                value: this.model.get('name'),
                onSave: _.bind(function (value) {
                    this.model.patch({
                        name: value
                    });
                }, this)
            });

            new PJQ.views.punchlists.PunchlistView({
                el: this.$('.manage-template'),
                model: this.model,
                collection: this.model.punchlistItems
            });
        }
    },
    close: function () {
        if (typeof this.options.onClose === 'function') {
            this.options.onClose(this.model);
        }
    },
    deleteTemplate: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this template?",
            onDelete: _.bind(function () {
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});


PJQ.views.punchlists.TemplateManagement = PJQ.views.templates.TemplateManagement.extend({
    beforeFirstRender: function () {
        this.collection = new PJQ.collections.punchlists.Templates();
        this.listenTo(this.collection, 'fetch', this.render);
        this.collection.fetch();
    },
    addTemplate: function () {
        new PJQ.views.templates.NewTemplateModal({
            model: new PJQ.models.punchlists.Template(),
            onSave: _.bind(function (template) {
                this.collection.add(template);
                this.editTemplate(template);
            }, this)
        });
    },
    editTemplate: function (template) {
        new PJQ.views.punchlists.EditTemplateModal({
            model: template,
            onClose: _.bind(function () {
                this.dataTable.refresh();
            }, this),
            onDelete: _.bind(function (template) {
                if (template.id > 0) {
                    let row = this.dataTable.getRow(template.cid);
                    this.collection.remove(template);
                    template.destroy();
                    this.dataTable.removeRow(row);
                }
            }, this)
        });
    }
});
